import { render } from "./GrupoSocioNegocioForm.vue?vue&type=template&id=0f8e2220&scoped=true"
import script from "./GrupoSocioNegocioForm.vue?vue&type=script&lang=js"
export * from "./GrupoSocioNegocioForm.vue?vue&type=script&lang=js"

import "./GrupoSocioNegocioForm.vue?vue&type=style&index=0&id=0f8e2220&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8e2220"]])

export default __exports__